import type { CatalogEntry } from './types';
import { ERROR_CATALOG } from './catalog';
import { RESERVED } from './reserved';

/** Look up a catalog entry; falls back to the unhandled-500 entry for unknown codes. */
export function lookup(code: string): CatalogEntry {
  return ERROR_CATALOG[code] ?? ERROR_CATALOG[RESERVED.UNHANDLED];
}

/** Split a 6-digit code into its `FFAAEE` segments. */
export function decode(code: string): { feature: string; endpoint: string; condition: string } {
  return {
    feature: code.slice(0, 2),
    endpoint: code.slice(2, 4),
    condition: code.slice(4, 6),
  };
}

/** True when `code` is a 6-digit string present in the catalog. */
export function isErrorCode(code: string): boolean {
  return /^\d{6}$/.test(code) && code in ERROR_CATALOG;
}
